import { CalendarProvider as ServerlessProvider } from '@wix/ambassador-asa-calendar-oauth-v1-calendar-oauth/types';
import { Provider as ApiProvider } from '@wix/ambassador-asa-token-v1-token/types';
import { CalendarProvider } from '../../commonTypes';
export function apiProviderToCalendarProvider(provider) {
  switch (provider) {
    case ApiProvider.GOOGLE:
      return CalendarProvider.GOOGLE;
    case ApiProvider.ICLOUD:
      return CalendarProvider.ICLOUD;
    case ApiProvider.MICROSOFT:
      return CalendarProvider.MICROSOFT;
    default:
      throw new Error('unknown calendar provider');
  }
}
export function calendarProviderToApiProvider(provider) {
  switch (provider) {
    case CalendarProvider.GOOGLE:
      return ApiProvider.GOOGLE;
    case CalendarProvider.ICLOUD:
      return ApiProvider.ICLOUD;
    case CalendarProvider.MICROSOFT:
      return ApiProvider.MICROSOFT;
    default:
      return ApiProvider.UNKNOWN;
  }
}
export function nylasProviderToCalendarProvider(provider) {
  switch (provider) {
    case 'google':
      return CalendarProvider.GOOGLE;
    case 'microsoft':
      return CalendarProvider.MICROSOFT;
    case 'icloud':
      return CalendarProvider.ICLOUD;
    case 'imap':
    case 'virtual-calendar':
    default:
      throw new Error('unknown calendar provider');
  }
}
export function calendarProviderToNylasProvider(provider) {
  switch (provider) {
    case CalendarProvider.GOOGLE:
      return 'google';
    case CalendarProvider.MICROSOFT:
      return 'microsoft';
    case CalendarProvider.ICLOUD:
      return 'icloud';
    default:
      throw new Error(`${provider} is invalid provider`);
  }
}
export function calendarProviderToServerlessProvider(provider) {
  switch (provider) {
    case CalendarProvider.GOOGLE:
      return ServerlessProvider.GOOGLE;
    case CalendarProvider.MICROSOFT:
      return ServerlessProvider.MICROSOFT;
    case CalendarProvider.ICLOUD:
      return ServerlessProvider.ICLOUD;
    default:
      return ServerlessProvider.UNKNOWN;
  }
}
export function serverlessProviderToCalendarProvider(provider) {
  switch (provider) {
    case ServerlessProvider.GOOGLE:
      return CalendarProvider.GOOGLE;
    case ServerlessProvider.MICROSOFT:
      return CalendarProvider.MICROSOFT;
    case ServerlessProvider.ICLOUD:
      return CalendarProvider.ICLOUD;
    default:
      throw new Error('unknown calendar provider');
  }
}
//# sourceMappingURL=converters.js.map